<template>
    <div>
        <div class="flex-col justify-start items-start flex">
            <!-- START ALERT-SPECIFIC DETAILS -->
            <div class="self-stretch justify-start items-center gap-1.5 flex">
                <div class="text-slate-500 text-sm font-normal leading-tight">
                    {{ alertDatesString }}
                </div>
                <div class="w-0.5 h-0.5 bg-slate-500 rounded-full"></div>

                <div class="text-slate-500 text-sm font-normal leading-tight">
                    {{ $filters.ucWords(activeAlert.alert_type) }}
                </div>
                <div
                    class="w-0.5 h-0.5 bg-slate-500 rounded-full"
                    v-if="activeAlert.max_points"
                ></div>
                <div
                    class="text-slate-500 text-sm font-normal leading-tight"
                    v-if="activeAlert.max_points"
                >
                    {{ $filters.formatThousand(activeAlert.max_points) }}
                </div>
            </div>
            <!-- END ALERT-SPECIFIC DETAILS -->
            <!-- START EDIT BUTTONS -->
            <div
                class="bg-white justify-start items-start flex pt-4 gap-2 self-stretch"
            >
                <button
                    class="px-4 py-2 bg-white rounded shadow border border-slate-200 justify-start items-center gap-2 flex hover:bg-slate-200 hover:border-slate-300 active:border-slate-300 active:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-200 focus:ring-offset-0"
                    :disabled="
                        activeAlert.status === 'unavailable' ||
                        activeAlert.status === 'expired'
                    "
                    @click="toggleComplete(activeAlert)"
                >
                    <Icon
                        :icon="activeAlert?.complete ? 'reset' : 'checkmark'"
                        svgClass="w-5 h-5"
                    />
                    <span
                        class="text-slate-800 text-sm font-medium font-['Inter'] leading-tight"
                    >
                        {{
                            activeAlert.complete
                                ? 'Set active '
                                : 'Mark complete'
                        }}
                    </span>
                </button>
                <button
                    class="px-4 py-2 bg-white rounded shadow border border-slate-200 justify-start items-center gap-2 flex hover:bg-slate-200 hover:border-slate-300 active:border-slate-300 active:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-200 focus:ring-offset-0"
                    @click="$emit('edit')"
                    type="button"
                    tabindex="0"
                >
                    <Icon icon="pencil" svgClass="w-5 h-5" />
                </button>
                <button
                    @click="$emit('delete')"
                    type="button"
                    tabindex="0"
                    class="px-4 py-2 bg-white rounded shadow border border-slate-200 justify-start items-center gap-2 flex hover:bg-slate-200 hover:border-slate-300 active:border-slate-300 active:bg-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-200 focus:ring-offset-0"
                >
                    <Icon icon="trash" svgClass="w-5 h-5" />
                </button>
            </div>
            <!-- END EDIT BUTTONS -->
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAlertsStore } from '@/store/alerts';
import Icon from '@/components/ui/icon/icon.vue';
import dayjs from 'dayjs';

export default {
    props: {},
    components: { Icon },
    emits: ['delete', 'edit'],
    setup() {
        const alertsStore = useAlertsStore();
        const { activeAlert } = storeToRefs(alertsStore);
        const { toggleComplete } = alertsStore;

        const alertDatesString = computed(() => {
            const { alert_type, check_in, check_out, number_of_nights } =
                activeAlert.value;
            const startDate = dayjs(check_in);
            const endDate = dayjs(check_out);

            if (alert_type === 'flexible') {
                const monthYear = startDate.format('MMMM YYYY');
                const formattedNights =
                    number_of_nights > 1 ? 'nights' : 'night';
                return `${monthYear}, ${number_of_nights} ${formattedNights}`;
            } else {
                const start = startDate.format('MMM DD');
                const end = endDate.format('MMM DD');
                const duration = endDate.diff(startDate, 'day');
                const formattedDuration = duration > 1 ? 'nights' : 'night';
                return `${start} - ${end}, ${duration} ${formattedDuration}`;
            }
        });
        return { activeAlert, alertDatesString, toggleComplete };
    },
};
</script>
